var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconGroupDetail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 5,
    fill: "#161615"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3009 4V11.9473H11.3752V6.92565C11.3752 6.14972 11.6835 5.40556 12.2321 4.85689C12.7808 4.30823 13.525 4 14.3009 4Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5979 11.9036H14.3009V15.5715C14.3009 15.7916 14.2135 16.0026 14.0579 16.1582C13.9023 16.3138 13.6913 16.4012 13.4712 16.4012H13.4276C13.2075 16.4012 12.9965 16.3138 12.8409 16.1582C12.6853 16.0026 12.5979 15.7916 12.5979 15.5715V11.9036Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.00865 16.4013C6.74229 16.4013 6.48684 16.2955 6.29849 16.1072C6.11014 15.9188 6.00433 15.6634 6.00433 15.397L6.441 9.93872H7.61998L8.05664 15.397C8.05677 15.5327 8.02943 15.6669 7.97625 15.7917C7.92306 15.9165 7.84515 16.0292 7.74721 16.1231C7.64928 16.2169 7.53335 16.29 7.40642 16.3378C7.27948 16.3856 7.14417 16.4072 7.00865 16.4013Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.97363 7.97363C8.90283 8.44995 8.66325 8.88498 8.29857 9.19945C7.93389 9.51393 7.46837 9.68693 6.98682 9.68693C6.50527 9.68693 6.03975 9.51393 5.67506 9.19945C5.31038 8.88498 5.07081 8.44995 5 7.97363H8.97363Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5 4.34937V7.97367",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.96497 4.34937V7.88634",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.97357 4.34937V7.97367",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGroupDetail);
export default __webpack_public_path__ + "static/media/icon-group-detail.949ba71758083f19488c2a502fca4e31.svg";
export { ForwardRef as ReactComponent };